import { View } from "./Inventory.view";

export const Container = () => {
  return <View />;
};
